// import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { AppBar, Hidden, IconButton, Toolbar, SvgIcon, Link } from '@mui/material';
import { Menu as MenuIcon } from 'react-feather';
import Logo from 'components/Logo';

const styles = {
  toolbar: {
    minHeight: 64
  },
  appBar: {
    backgroundColor: '#2e2e2e'
  },
  separator: {
    background: '#111111',
    borderRight: '1px solid #3B3B3B',
    float: 'left',
    height: '42px',
    width: '1px',
    marginRight: '10px',
    marginLeft: '10px'
  }
};

function TopBar({ className, onMobileNavOpen, ...rest }: any) {
  return (
    <AppBar sx={styles.appBar} className={clsx(styles.appBar, className)} {...rest}>
      <Toolbar sx={styles.toolbar}>
        {/* MENU */}
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>

        {/* LOGO */}
        <Hidden mdDown>
          <Link href="/wiki">
            <Logo />
          </Link>
        </Hidden>
        <div
          style={{
            background: '#111111',
            borderRight: '1px solid #3B3B3B',
            float: 'left',
            height: '42px',
            width: '1px',
            marginRight: '10px',
            marginLeft: '10px'
          }}
        />
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
